export const experience = [
  {
    role: 'Frontend Developer',
    org: 'ACM at UC San Diego',
    start: 'May 2026',
    end: 'Present',
    current: true,
    summary: 'Build and maintain ACM’s React websites, turning the design team’s Figma mockups into production pages, including the site for DiamondHacks, ACM’s annual hackathon.',
  },
  {
    role: 'Product Designer',
    org: 'West Coast Adult Soccer League',
    start: 'Apr 2025',
    end: 'Present',
    current: true,
    summary: 'Designed and launched a Squarespace site from scratch for a South Orange County league with 800+ players across four divisions.',
    link: '/case-study/wcasl',
  },
  {
    role: 'Hack Project Mentor (SWE)',
    org: 'ACM at UC San Diego',
    start: 'Oct 2025',
    end: 'Jan 2026',
    summary: "Co-mentored a team of 5 through ACM Hack's quarterly projects program as they built Decidr, a cross-platform dining recommendation app.",
  },
  {
    role: 'Product Designer',
    org: 'Plastic Beach',
    start: 'Apr 2025',
    end: 'Jul 2025',
    summary: 'Redesigned the website and recycling placard for a SoCal nonprofit reducing soft-plastic waste across 40+ retail and distribution partners.',
    link: '/case-study/plastic-beach',
  },
  {
    role: 'Student Intern',
    org: 'UC San Diego Health',
    start: 'Jun 2022',
    end: 'Aug 2022',
    summary: 'OPTIMUS Program at the Center for Health Equity, Education, and Research (CHEER).',
  },
];

export const education = [
  {
    role: 'B.S. Computer Science',
    org: 'UC San Diego',
    start: 'Sep 2023',
    end: 'Jun 2027',
    summary: 'Minor in Cognitive Science.',
  },
];
